import { z } from "zod";

export const CreateBrandFormValuesZod = z.object({
  brandName: z.string().min(1, "Brand name is required"),
  brandWebAddress: z.string().optional(),
  guidelineS3Key: z.string().nullable().default(null),
  logoS3Key: z.string().nullable().default(null),
});

export type CreateBrandFormValues = z.infer<typeof CreateBrandFormValuesZod>;
